<!--page starts-->
<section class="page-wrapper">
	<div class="ashton-hero-top fixtures">
		<div class="container">
			<div class="fixtures-top-detail">
				<div class="red-titel">League Table</div>
				
			</div>
            <div class="point-table-section">
                <div class="point-table-detail">
                    
					<iframe src="https://ashtonunited.co.uk/pointtable.html" title="W3Schools Free Online Web Tutorials"></iframe>
                    
                </div> 
            </div>
		</div>
		
	</div>
</section><!-- page ends -->